module.exports = __webpack_public_path__ + "ea7e6077946d4086bf363c1ffb91b658.svg";